export default __webpack_public_path__ + "static/media/sbj-chemistry.9dcf1889.svg";